import {
  GET_HEALTH_CHECK_SYNC_BILLING_STARTED,
  GET_HEALTH_CHECK_SYNC_BILLING_SUCCESS
} from '../../actions/actionTypes'

const defaultState = {
  hotelData: [],
  hotelGroups: {},
  hotelChains: {},
  isLoading: true,
  totalCount: 0,
  totalBalanceRemaining: 0,
  pageBalanceRemaining: 0,
  pageItemCount: 0,
  pageIndex: 1,
  pageSize: 50
}

export default function billings(state = { ...defaultState }, action) {
  switch (action.type) {
    case GET_HEALTH_CHECK_SYNC_BILLING_STARTED:
      return {
        ...state,
        isLoading: true
      }

    case GET_HEALTH_CHECK_SYNC_BILLING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hotelData: action.payload.hotelData,
        hotelGroups:
          Object.keys(action.payload.hotelGroups || {}).length > 0
            ? action.payload.hotelGroups
            : state.hotelGroups,
        hotelChains:
          Object.keys(action.payload.hotelChains || {}).length > 0
            ? action.payload.hotelChains
            : state.hotelChains,
        totalCount: action.payload.totalCount,
        totalBalanceRemaining: action.payload.totalBalanceRemaining,
        pageBalanceRemaining: action.payload.pageBalanceRemaining,
        pageItemCount: action.payload.pageItemCount,
        pageIndex: action.payload.pageIndex,
        pageSize: action.payload.pageSize
      }

    case 'SAVE_POSTED_SUBSIDIARY':
      return {
        ...defaultState
      }

    default:
      return state
  }
}
